<template>
  <div :class="`as-goals-scored`">
    <div class="as-goals-scored__head">
      <IconGoalScored />
      <span> Cả hai đội đều ghi bàn </span>
    </div>
    <div class="as-history">
      <div class="as-history-item">
        <div class="as-history-item__head">
          <div
            class="as-head-tab"
            :class="{ 'as-active': activeTab === 'all' }"
            @click="setActiveTab('all')"
          >
            Cả trận
          </div>
          <div
            class="as-head-tab"
            :class="{ 'as-active': activeTab === 'half' }"
            @click="setActiveTab('half')"
          >
            Hiệp 1/2
          </div>
        </div>
        <div class="as-history-item__body">
          <div class="as-competition" v-if="activeTab === 'all'">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>BTTS</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">AVG</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>BTTS</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.seasonBTTSPercentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.seasonBTTSPercentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.seasonBTTSPercentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.seasonBTTSPercentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.seasonBTTSPercentage_overall,
                        awayTeamLastX.stats.seasonBTTSPercentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.seasonBTTSPercentage_overall,
                        awayTeamLastX.stats.seasonBTTSPercentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>BTTS & Thắng</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.BTTS_and_win_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.BTTS_and_win_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.BTTS_and_win_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.BTTS_and_win_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_and_win_percentage_overall,
                        awayTeamLastX.stats.BTTS_and_win_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_and_win_percentage_overall,
                        awayTeamLastX.stats.BTTS_and_win_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>BTTS & Hòa</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.BTTS_and_draw_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.BTTS_and_draw_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.BTTS_and_draw_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.BTTS_and_draw_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_and_draw_percentage_overall,
                        awayTeamLastX.stats.BTTS_and_draw_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_and_draw_percentage_overall,
                        awayTeamLastX.stats.BTTS_and_draw_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>BTTS & Thua</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.BTTS_and_lose_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.BTTS_and_lose_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.BTTS_and_lose_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.BTTS_and_lose_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_and_lose_percentage_overall,
                        awayTeamLastX.stats.BTTS_and_lose_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_and_lose_percentage_overall,
                        awayTeamLastX.stats.BTTS_and_lose_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>BTTS & Trên 2.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.additional_info
                        .over25_and_btts_percentage_overall
                    )}`"
                  >
                    {{
                      homeTeamLastX.stats.additional_info
                        .over25_and_btts_percentage_overall
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.additional_info
                        .over25_and_btts_percentage_overall
                    )}`"
                  >
                    {{
                      awayTeamLastX.stats.additional_info
                        .over25_and_btts_percentage_overall
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.additional_info
                          .over25_and_btts_percentage_overall,
                        awayTeamLastX.stats.additional_info
                          .over25_and_btts_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.additional_info
                          .over25_and_btts_percentage_overall,
                        awayTeamLastX.stats.additional_info
                          .over25_and_btts_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>BTTS No & Trên 2.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.additional_info
                        .over25_and_no_btts_percentage_overall
                    )}`"
                  >
                    {{
                      homeTeamLastX.stats.additional_info
                        .over25_and_no_btts_percentage_overall
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.additional_info
                        .over25_and_no_btts_percentage_overall
                    )}`"
                  >
                    {{
                      awayTeamLastX.stats.additional_info
                        .over25_and_no_btts_percentage_overall
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.additional_info
                          .over25_and_no_btts_percentage_overall,
                        awayTeamLastX.stats.additional_info
                          .over25_and_no_btts_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.additional_info
                          .over25_and_no_btts_percentage_overall,
                        awayTeamLastX.stats.additional_info
                          .over25_and_no_btts_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="as-competition" v-if="activeTab === 'half'">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>First Half Goals</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">AVG</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>BTTS First Half</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.btts_fhg_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.btts_fhg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.btts_fhg_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.btts_fhg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.btts_fhg_percentage_overall,
                        awayTeamLastX.stats.btts_fhg_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.btts_fhg_percentage_overall,
                        awayTeamLastX.stats.btts_fhg_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 0.5 FH</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.seasonOver05PercentageHT_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.seasonOver05PercentageHT_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.seasonOver05PercentageHT_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.seasonOver05PercentageHT_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.seasonOver05PercentageHT_overall,
                        awayTeamLastX.stats.seasonOver05PercentageHT_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.seasonOver05PercentageHT_overall,
                        awayTeamLastX.stats.seasonOver05PercentageHT_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 1.5 FH</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.seasonOver15PercentageHT_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.seasonOver15PercentageHT_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.seasonOver15PercentageHT_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.seasonOver15PercentageHT_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.seasonOver15PercentageHT_overall,
                        awayTeamLastX.stats.seasonOver15PercentageHT_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.seasonOver15PercentageHT_overall,
                        awayTeamLastX.stats.seasonOver15PercentageHT_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 2.5 FH</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.seasonOver25PercentageHT_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.seasonOver25PercentageHT_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.seasonOver25PercentageHT_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.seasonOver25PercentageHT_overall }}%
                  </td>
                  <td class="as-center as-L">
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.seasonOver25PercentageHT_overall,
                        awayTeamLastX.stats.seasonOver25PercentageHT_overall
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>2nd Half Goals</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">AVG</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>BTTS 2nd Half</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.btts_2hg_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.btts_2hg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.btts_2hg_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.btts_2hg_percentage_overall }}%
                  </td>
                  <td class="as-center as-W">
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.btts_2hg_percentage_overall,
                        awayTeamLastX.stats.btts_2hg_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>BTTS Both Halves</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.BTTS_both_halves_percentage_overall
                    )}`"
                  >
                    {{
                      homeTeamLastX.stats.BTTS_both_halves_percentage_overall
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.BTTS_both_halves_percentage_overall
                    )}`"
                  >
                    {{
                      awayTeamLastX.stats.BTTS_both_halves_percentage_overall
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_both_halves_percentage_overall,
                        awayTeamLastX.stats.BTTS_both_halves_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.BTTS_both_halves_percentage_overall,
                        awayTeamLastX.stats.BTTS_both_halves_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 0.5 2H</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.over05_2hg_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.over05_2hg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.over05_2hg_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.over05_2hg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.over05_2hg_percentage_overall,
                        awayTeamLastX.stats.over05_2hg_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.over05_2hg_percentage_overall,
                        awayTeamLastX.stats.over05_2hg_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 1.5 2H</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.over15_2hg_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.over15_2hg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.over15_2hg_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.over15_2hg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.over15_2hg_percentage_overall,
                        awayTeamLastX.stats.over15_2hg_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.over15_2hg_percentage_overall,
                        awayTeamLastX.stats.over15_2hg_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Over 2.5 2H</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      homeTeamLastX.stats.over25_2hg_percentage_overall
                    )}`"
                  >
                    {{ homeTeamLastX.stats.over25_2hg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      awayTeamLastX.stats.over25_2hg_percentage_overall
                    )}`"
                  >
                    {{ awayTeamLastX.stats.over25_2hg_percentage_overall }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        homeTeamLastX.stats.over25_2hg_percentage_overall,
                        awayTeamLastX.stats.over25_2hg_percentage_overall
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        homeTeamLastX.stats.over25_2hg_percentage_overall,
                        awayTeamLastX.stats.over25_2hg_percentage_overall
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconGoalScored from "~src/components/icons/foot_stats/IconGoalScored.vue";
import type { IMatch } from "~src/interfaces";
import { ref, computed } from "vue";
import type {
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { getClassForItem } from "~src/helpers/footystats";

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

const props = withDefaults(defineProps<Props>(), {
  mode: "as-win",
});

const activeTab = ref("all");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};
</script>

<script lang="ts">
export default {};
</script>
